import a11y from "../A11y/reducer";
import app from "../App/reducer";
import author from "../Author/reducer";
import content from "../Content/reducer";
import cookieJar from "../CookieJar/reducer";
import detail from "../Detail/reducer";
import dmp from "../DMP/reducer";
import featureflags from "../FeatureFlags/reducer";
import feedback from "../Feedback/reducer";
import fixed from "../Fixed/reducer";
import flp from "../FLP/reducer";
import gdpr from "../Gdpr/reducer";
import liveRadio from "../LiveRadio/reducer";
import liveStory from "../LiveStory/reducer";
import loader from "../Loader/reducer";
import navigation from "../Navigation/reducer";
import newsletters from "../Newsletters/reducer";
import page from "../Page/reducer";
import persistentPlayer from "../PersistentPlayer/reducer";
import personalization from "../Personalization/reducer";
import preferences from "../Preferences/reducer";
import regions from "../Regions/reducer";
import rightRail from "../RightRail/reducer";
import search from "../Search/reducer";
import sectionalContent from "../SectionalContent/reducer";
import schedule from "../Schedule/reducer";
import singleLineup from "../SingleLineup/reducer";
import ssr from "../SSR/reducer";
import subjectContent from "../SubjectContent/reducer";
import tracking from "../Tracking/reducer";
import trending from "../Trending/reducer";
import video from "../Video/reducer";
import videoDetail from "../VideoDetail/reducer";

const allReducers = {
    a11y,
    app,
    author,
    content,
    cookieJar,
    detail,
    dmp,
    featureflags,
    feedback,
    fixed,
    flp,
    gdpr,
    liveRadio,
    liveStory,
    loader,
    navigation,
    newsletters,
    page,
    persistentPlayer,
    personalization,
    preferences,
    regions,
    rightRail,
    schedule,
    search,
    sectionalContent,
    singleLineup,
    ssr,
    subjectContent,
    tracking,
    trending,
    video,
    videoDetail,
};

export default allReducers;
